export const mfaErrors = {
	INVALID_CHALLENGE: 'invalid_challenge',
	EXPIRED_OTP: 'expired_otp',
	TOO_MANY_ATTEMPTS: 'too_many_attempts',
	OTP_INVALID: 'otp_invalid',
	RESEND_LIMIT_EXCEEDED: 'resend_limit_exceeded',
	TOO_EARLY_RESEND: 'too_early_resend'
} as const

export type MfaError = typeof mfaErrors[keyof typeof mfaErrors]